import Vue from 'vue'

export function mapFilters(filters) {
    return filters.reduce((result, filter) => {
        result[filter] = function(...args) {
            return Vue.options.filters[filter](...args);
        };
        return result;
    }, {});
}